import React, { useEffect, useRef } from "react";

// Interactive itinerary map (Leaflet + OpenStreetMap, no API key). Points come from tour data.
export function TourMap({ points = [] }) {
  const elRef = useRef(null);
  const mapRef = useRef(null);

  useEffect(() => {
    if (!points || points.length === 0) return;
    let disposed = false;
    (async () => {
      const L = (await import("leaflet")).default;
      await import("leaflet/dist/leaflet.css");
      if (disposed || !elRef.current || mapRef.current) return;
      const map = L.map(elRef.current, { scrollWheelZoom: false, zoomControl: true });
      mapRef.current = map;
      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution: '&copy; OpenStreetMap contributors', maxZoom: 18,
      }).addTo(map);

      const latlngs = points.map((p) => [p.lat, p.lng]);
      points.forEach((p, i) => {
        const icon = L.divIcon({
          className: "vg-pin",
          html: `<span class="vg-pin-dot">${p.day || i + 1}</span>`,
          iconSize: [28, 28], iconAnchor: [14, 14],
        });
        L.marker([p.lat, p.lng], { icon }).addTo(map).bindPopup(`<b>Day ${p.day || i + 1}</b><br/>${p.name}`);
      });
      if (latlngs.length > 1) {
        L.polyline(latlngs, { color: "#F49E1A", weight: 3, opacity: 0.85, dashArray: "1,8", lineCap: "round" }).addTo(map);
        map.fitBounds(latlngs, { padding: [40, 40], maxZoom: 9 });
      } else {
        map.setView(latlngs[0], 9);
      }
      setTimeout(() => map.invalidateSize(), 200);
    })();
    return () => { disposed = true; if (mapRef.current) { mapRef.current.remove(); mapRef.current = null; } };
  }, [points]);

  if (!points || points.length === 0) return null;
  return (
    <div className="relative z-0">
      <div ref={elRef} data-testid="tour-map" className="w-full h-[360px] rounded-md overflow-hidden border border-[#553204]/12" />
      <div className="mt-2 flex flex-wrap gap-x-4 gap-y-1 text-xs text-[#8A6B47]">
        {points.map((p, i) => (
          <span key={`${p.name}-${i}`} className="inline-flex items-center gap-1.5"><span className="inline-flex h-4 w-4 items-center justify-center rounded-full bg-[#F49E1A] text-white text-[9px] font-bold">{p.day || i + 1}</span>{p.name}</span>
        ))}
      </div>
    </div>
  );
}
